<template>
    <div class="form-group">
        <label class="form-label section-title">{{ $t('messages.device') }}</label>
        <div class="card-grid">
            <div v-for="device in devices" :key="device.id"
                :class="['card', { active: localData.devices.includes(device.id) }]" @click="toggleDevice(device.id)">
                <div class="card-icon">
                    <img :src="device.icon" :alt="device.label" />
                </div>
                <div class="card-label">{{ device.label }}</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "DeviceTypes",
    props: {
        data: {
            type: Object,
            required: true
        },
        deviceTypes: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            localData: {
                devices: []
            }
        };
    },
    computed: {
        devices() {
            const deviceMapping = {
                2: { label: this.$t('messages.computer'), icon: '/images/desktop.svg' },
                302: { label: this.$t('messages.tablet'), icon: '/images/tablet.svg' },
                202: { label: this.$t('messages.smartphone'), icon: '/images/smartphone.svg' },
                502: { label: this.$t('messages.tv'), icon: '/images/tv.svg' }
            };
            return this.deviceTypes
                .filter(device => deviceMapping[device.id])
                .map(device => ({
                    id: device.id,
                    device_type: device.device_type,
                    label: deviceMapping[device.id].label,
                    icon: deviceMapping[device.id].icon
                }));
        }
    },
    watch: {
        data: {
            handler(newData) {
                if (newData && newData.devices) {
                    this.localData.devices = [...newData.devices];
                }
            },
            immediate: true,
            deep: true
        }
    },
    methods: {
        toggleDevice(deviceId) {
            const index = this.localData.devices.indexOf(deviceId);
            if (index > -1) {
                this.localData.devices.splice(index, 1);
            } else {
                this.localData.devices.push(deviceId);
            }
            this.updateData();
        },

        updateData() {
            this.$emit('update', {
                devices: this.localData.devices
            });
        },

        validateSelection() {
            return this.localData.devices.length > 0;
        },
    }
};
</script>